<script setup lang="ts">
import { StaticPage } from '~/enums/static-page'
import type { Team } from '~/types'

defineOptions({
  name: 'TeamStatsWrapper',
})

interface Props {
  team: Team.Model
}

const props = defineProps<Props>()

const { sponsor } = useSponsor(StaticPage.Stats, props.team)
</script>

<template>
  <div class="team-stats-wrapper">
    <Wrapper>
      <div class="team-stats-wrapper__heading">
        <UIDynamicHeading as="h1">
          <slot name="title" />
        </UIDynamicHeading>

        <UISponsor
          v-if="sponsor"
          v-bind="sponsor"
          class="team-stats-wrapper__sponsor"
        />

        <div class="team-stats-wrapper__subtitle">
          <slot name="subtitle" />
        </div>
      </div>

      <slot />
    </Wrapper>
  </div>
</template>

<style lang="scss" scoped>
.team-stats-wrapper {
  @apply pb-[30px];
  @apply lg:pb-[50px];

  &__heading {
    @apply flex flex-col justify-between gap-[20px];
    @apply md:flex-row md:gap-0;
  }

  &__sponsor {
    @apply lg:ml-6 lg:mr-auto;
  }
}
</style>
